var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.16 12.3201L17.08 8.74013L10.16 5.13013V12.3201Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3301 3.88C25.3301 3.88 25.0802 2.12 24.3105 1.34C23.3409 0.32 22.2513 0.32 21.7415 0.26C18.173 0 12.805 0 12.805 0H12.795C12.795 0 7.4271 0 3.8385 0.26C3.3387 0.32 2.2491 0.32 1.2695 1.34C0.5098 2.12 0.2599 3.88 0.2599 3.88C0.2599 3.88 0 5.96 0 8.03V9.97C0 12.04 0.2599 14.11 0.2599 14.11C0.2599 14.11 0.5098 15.87 1.2795 16.65C2.2491 17.67 3.5286 17.64 4.0984 17.74C6.1476 17.94 12.795 18 12.795 18C12.795 18 18.1729 17.99 21.7515 17.73C22.2513 17.67 23.3409 17.67 24.3205 16.65C25.0902 15.87 25.3401 14.11 25.3401 14.11C25.3401 14.11 25.6 12.04 25.6 9.97V8.03C25.59 5.96 25.3301 3.88 25.3301 3.88ZM10.1561 12.32V5.13L17.0733 8.74L10.156 12.32H10.1561Z",
    fill: "#E52D27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.8b58c1a247087c7958ce4c6fd884eced.svg";
export { ForwardRef as ReactComponent };